import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { checkAccessToken } from '@/utils/handle-authentication';
import { getEmployeeInfoAction } from '@/redux/actions/employee';
import { getEmployeeInfo, TGetEmployeeInfoResponse } from '@/services/api/employee';
import { handleAPIError } from '@/utils/handle-api-error';

// FUNCTION
export function* getEmployeeInfoSaga(action: ActionType<typeof getEmployeeInfoAction.request>): Generator {
  const { companyId, employeeId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(getEmployeeInfo, companyId, employeeId);
    const getEmployeeInfoResponse: TGetEmployeeInfoResponse = response as TGetEmployeeInfoResponse;
    yield put(getEmployeeInfoAction.success(getEmployeeInfoResponse));
    successCallback?.(getEmployeeInfoResponse);
  } catch (err) {
    handleAPIError(err, 'Error.getEmployeeInfoError');
    yield put(getEmployeeInfoAction.failure(err));
    failedCallback?.(err);
  }
}
